import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SocialLink } from '@bd/bdcore-utilities';

import { colors } from '../../styles';
import OSCTagMobile from './OSCTagMobile';

const styles = css`
  .Footer_topWrapper {
    height: 62px;
    background-color: rgba(214, 155, 41, 0.1);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    @media(min-width: 992px) {
      padding: 0 40px;
      height: 132px;
    }
    @media(min-width: 1300px) {
      padding: 0 100px;
    }
    .Footer_socialList {
      li {
        transition: all .3s ease-out;
        & + li {
          padding: 0 0 0 22px;
        }
        &:hover {
          opacity: .6;
        }
      }
    }
  }
  .Footer_socialText {
    font-weight: 800;
    font-size: 16px;
    color: #000000;
    letter-spacing: 2.82px;
    text-transform: uppercase;
  }
  .Footer_bottomWrapper {
    display: flex;
    flex-direction: column;
    padding: 24px 20px 90px;
    @media(min-width: 992px) {
      flex-direction: row;
      padding: 35px 40px 60px;
    }
    @media(min-width: 1300px) {
      padding: 35px 100px 65px;
    }
  }
  .Footer_linksItem {
    font-weight: 700;
    font-size: 15px;
    color: #000000;
    letter-spacing: 0;
    line-height: 25px;
    transition: all .3s ease-out;
    margin: 0 10px 0 0;
    &:hover {
      color: ${colors.color1};
    }
  }
  .Footer_builder {
    font-size: 13px;
    color: #393939;
    letter-spacing: 0;
    line-height: 20px;
    margin: 30px 0 0;
    @media(min-width: 992px) {
      margin: 0;
    }
  }
  .Footer_linksText {
    font-weight: 400;
    font-size: 13px;
    color: #393939;
    letter-spacing: 0;
    line-height: 20px;
  }

  .Footer_houzzImage {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }
`;

function Footer({ builder, community }) {
  return (
    <div className={styles}>
      <div className="Footer_topWrapper">
        <ul className="list-unstyled d-flex flex-lg-fill m-0 Footer_socialList">
          <span className="d-none d-lg-flex Footer_socialText mr-4">Let&#39;s be friends!</span>
          {
            get(builder, 'socialLinks', []).map(link => (
              <li key={link}>
                <SocialLink
                  url={link}
                />
              </li>
            ))
          }
        </ul>
      </div>
      <div className="Footer_bottomWrapper">
        <div className="Footer_content d-lg-flex flex-column flex-fill">
          <div className="d-lg-flex Footer_linksText">
            <span>&copy;{(new Date()).getFullYear()}&nbsp;{get(builder, 'name')}. All Rights Reserved.&nbsp;</span><br className="d-lg-none" />
            Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer" className="FooterBD_link ml-1"><b>Builder Designs</b></a>
          </div>
          <div className="d-none d-lg-flex mt-3">
            <Link name="homes" className="Footer_linksItem">Modern Homes</Link>
            <Link name="image-gallery" className="Footer_linksItem">Gallery</Link>
            <Link name="about-us" className="Footer_linksItem">About Us</Link>
            <Link name="contact-us" className="Footer_linksItem">Contact</Link>
            <Link name="privacy-policy" className="Footer_linksItem mx-0">Privacy Policy</Link>
          </div>
        </div>
        <div className="d-flex flex-column Footer_builder">
          <span><b>{get(builder, 'name')}</b></span>
          <span className="d-flex flex-column">{get(builder, 'address.streetAddress')}</span>
          <span className="d-flex flex-column">{get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}</span>
          <a href={`tel:${get(community, 'telephone', get(builder, 'telephone', '')).replace(/[^0-9]/g, '')}`}>PH: {get(community, 'telephone', get(builder, 'telephone')).replace(/\s-\s/, '-')}</a>
          <span><b>CBC License #: 1261506</b></span>

        </div>
      </div>
      <div className="d-lg-none">
        <OSCTagMobile builder={builder} />
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
  community: PropTypes.object,
};

Footer.defaultProps = {
  community: undefined,
};

export default withData(
  {
    builder: true,
    home: true,
    community: true,
  },
  {
    required: {
      builder: true,
    },
  },
)(Footer);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Footer.js